import { render, staticRenderFns } from "./alarm-icon.vue?vue&type=template&id=2cd1429a"
import script from "./alarm-icon.vue?vue&type=script&lang=js"
export * from "./alarm-icon.vue?vue&type=script&lang=js"
import style0 from "./alarm-icon.vue?vue&type=style&index=0&id=2cd1429a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports